<template>
  <div class="panel">
    <div class="flex">
      <el-button-group class="switch-btns">
        <el-button
          :type="switchBtnKey === 'evaluationOrderAmount' ? 'primary' : 'default'"
          @click="switchBtnHandler('evaluationOrderAmount')"
        >
          支付金额
        </el-button>
        <el-button
          :type="switchBtnKey === 'evaluationOrderCount' ? 'primary' : 'default'"
          @click="switchBtnHandler('evaluationOrderCount')"
        >
          购买次数
        </el-button>
        <el-button
          :type="switchBtnKey === 'agencyOrderCount' ? 'primary' : 'default'"
          @click="switchBtnHandler('agencyOrderCount')"
        >
          机构推荐次数
        </el-button>
      </el-button-group>
    </div>
    <div id="column" />
  </div>
</template>

<script>

import { Column } from '@antv/g2plot';

export default {
  name: 'Home',
  components: {},
  props: {
    panelData: {
      type: Object,
      default: () => ({ evaluationOrderAmount: [], evaluationOrderCount: [], agencyOrderCount: [] }),
    },
  },
  data() {
    return {
      switchBtnKey: 'evaluationOrderAmount',
      columnPlot: null,
    };
  },
  watch: {
    panelData() {
      this.renderColumn(this.panelData[this.switchBtnKey]);
    },
  },
  methods: {
    // 切换显示机构人员
    switchBtnHandler(val) {
      this.switchBtnKey = val;
      this.renderColumn(this.panelData[this.switchBtnKey]);
    },
    // 渲染柱状图
    renderColumn(data) {
      if (this.columnPlot) {
        this.columnPlot.destroy();
        this.columnPlot = null;
      }
      let alias = '';
      let xField = '';
      if (this.switchBtnKey === 'evaluationOrderAmount') {
        alias = '支付金额';
        xField = 'evaluationName';
      }
      if (this.switchBtnKey === 'evaluationOrderCount') {
        alias = '购买次数';
        xField = 'evaluationName';
      }
      if (this.switchBtnKey === 'agencyOrderCount') {
        alias = '机构推荐次数';
        xField = 'agencyName';
      }
      this.columnPlot = new Column('column', {
        data,
        xField,
        yField: 'value',
        color: '#FF7223',
        maxColumnWidth: 25,
        columnStyle: {
          radius: [2, 2, 0, 0],
        },
        meta: {
          value: {
            alias,
          },
        },
      });
      this.columnPlot.render();
    },
  },
};
</script>
<style lang="scss" scoped>
.panel{
  .header{
    display: flex;
    overflow-y: auto;
    .item{
      padding: 16px;
      display: flex;
      flex-direction: column;
      background: #F7F7F7;
      margin-right: 15px;
      flex: 1;
      .label{
        color:#979797;
        font-size: 14px;
        font-weight: 500;
      }
      .value{
        font-size: 32px;
        margin-top: 12px;
        font-weight: 800;
        color: $--base-color-main;
        display: flex;
        align-items: center;
        b{
          font-size: 18px;
        }
      }
    }
  }
  .border-bottom{
    border-bottom: 1px solid #EBEBEB;
  }
  .switch-btns{
    margin-bottom: 20px;
  }
  #column{
    height: 300px;
  }
  .pay-amount{
    display: flex;
    .items{
      background: #F7F7F7;
      margin-right: 16px;
      min-width: 170px;
      display: flex;
      flex-direction: column;
      padding: 16px;
      .item{
        margin-bottom: 25px;
        .label{
          color:#979797;
          font-size: 14px;
          font-weight: 500;
        }
        .value{
          font-size: 32px;
          margin-top: 12px;
          font-weight: 800;
          color: $--base-color-main;
          display: flex;
          align-items: center;
            b{
              font-size: 18px;
            }
        }
      }
    }
    #line{
      flex: 1,
    }
  }
}
</style>
